<template>
    <div
        class="file-display-card p-1 border rounded d-flex align-items-center justify-content-between"
        :class="{
            'has-file': url,
            'no-file': !url,
            'bg-light': !url,
        }"
    >
        <div class="d-flex align-items-center overflow-hidden">
            <div class="media-container mr-1">
                <div v-if="isImage && url" class="image-preview-wrapper" @click="openFile">
                    <b-img :src="url" class="rounded" style="width: 48px; height: 48px; object-fit: cover; cursor: pointer" alt="dosya önizleme" />
                </div>

                <div v-else class="icon-container rounded" :class="url ? 'bg-light-primary' : 'bg-light-secondary'">
                    <feather-icon :icon="url ? 'FileTextIcon' : 'FileMinusIcon'" size="24" :class="url ? 'text-primary' : 'text-muted'" />
                </div>
            </div>

            <div class="file-info text-truncate">
                <h6 class="mb-0 font-weight-bold text-truncate file-label" :class="{ 'text-muted': !url }">
                    {{ label }}
                </h6>
                <small v-if="url" class="text-success font-weight-bold">Dosya mevcut</small>
                <small v-else class="text-muted">Yüklenmedi</small>
            </div>
        </div>

        <div v-if="url">
            <b-button variant="flat-primary" size="sm" class="btn-icon rounded-circle ml-50" v-b-tooltip.hover title="Görüntüle / İndir" @click="openFile">
                <feather-icon icon="DownloadIcon" size="18" />
            </b-button>
        </div>
    </div>
</template>

<script>
import { BButton, VBTooltip, BImg } from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
    name: "FileDisplayCard",
    components: {
        BButton,
        FeatherIcon,
        BImg,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            default: null,
        },
    },
    computed: {
        isImage() {
            if (!this.url) return false;
            try {
                const extension = this.url.split(".").pop().toLowerCase().split("?")[0];
                return ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension);
            } catch (e) {
                return false;
            }
        },
    },
    methods: {
        openFile() {
            if (this.url) {
                window.open(this.url, "_blank");
            }
        },
    },
};
</script>

<style scoped>
.file-display-card {
    transition: all 0.3s ease;
    background-color: #fff;
    min-height: 70px;
}

.file-display-card.has-file:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    cursor: pointer;
}

.file-display-card.no-file {
    cursor: default;
}

.media-container {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
}

.icon-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-light-primary {
    background-color: rgba(115, 103, 240, 0.12);
}

.bg-light-secondary {
    background-color: rgba(130, 134, 139, 0.12);
}

.file-info {
    flex: 1;
    min-width: 0;
    padding-right: 10px;
}

.image-preview-wrapper {
    width: 48px;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
}
</style>

<style>
.dark-layout .file-display-card.has-file {
    background-color: #161d31 !important;
    border-color: #3b4253 !important;
}

.dark-layout .file-display-card.has-file:hover {
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.4) !important;
}

.dark-layout .file-display-card.has-file .file-label {
    color: #d0d2d6 !important;
}

.dark-layout .file-display-card.no-file {
    background-color: transparent !important;
    border: 1px dashed #3b4253 !important;
    opacity: 0.5;
}

.dark-layout .file-display-card.no-file .file-label {
    color: #676d7d !important;
}

.dark-layout .bg-light-secondary {
    background-color: #283046 !important;
}

.dark-layout .image-preview-wrapper {
    border-color: #3b4253 !important;
}
</style>
